import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("UI error boundary:", error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="font-display text-xl font-semibold text-slate-900">Something went wrong</div>
            <p className="mt-2 text-sm text-slate-500">An unexpected interface error occurred. Your data is safe — reload to continue where you left off.</p>
            <button onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              className="mt-4 rounded-lg bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm font-medium" data-testid="error-boundary-reload">
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
